module.exports = __webpack_public_path__ + "img/shield.21ad1617.svg";